import { StrictMode } from "react";
import { render } from "react-dom";
import { HashRouter } from "react-router-dom";
import "./index.css";
import { MsalProvider } from "@azure/msal-react";
import axios from "axios";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MsalInstance } from "./Auth/MsalInstance";
import { sanitizeObject } from "./security/sanitizeObject";

(function() {
  try {
    // 1. Lock the 'constructor' so it cannot be overwritten
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Object.prototype, "constructor", {
      writable: false,
      configurable: false
    });
  } catch (e) {
    console.warn("Security patch applied");
  }

  try {
    // 2. Prevent NEW properties from being added to the global Object prototype
    if (Object.isExtensible(Object.prototype)) {
      // eslint-disable-next-line no-extend-native
      Object.preventExtensions(Object.prototype);
    }
  } catch (e) {
    console.warn("Security patch failed to apply");
  }
})();

/// Sanitize all incoming API responses
axios.interceptors.response.use((response) => {
  try {
    sanitizeObject(response.data);
  } catch (e) {
    console.warn("Sanitization failed:", e);
  }
  return response;
});

// Sanitize outgoing requests too
axios.interceptors.request.use((config) => {
  try {
    if (config.data) sanitizeObject(config.data);
  } catch (e) {
    console.warn("Request sanitization failed:", e);
  }
  return config;
});


render(
  <StrictMode>
    <HashRouter>
      <MsalProvider instance={MsalInstance}>
        <App />
      </MsalProvider>
    </HashRouter>
  </StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
